"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxList/ListSearchField.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _icons = require('web/screens/Search/Refined/icons');
var _searchSession = require('web/screens/Search/Refined/searchSession');

const openSearch = () => _searchSession.searchSession.open()

/**
 * A search field at the top of the list. It opens the search
 * window, which searches all your chats and teams.
 */
const ListSearchField = () => (
  _react2.default.createElement('button', { type: "button", className: "inbox-list--search", onClick: openSearch, __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}
    , _react2.default.createElement(_icons.SearchIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}} )
    , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}, "Search")
    , _react2.default.createElement('kbd', { 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}, "⌘⇧F")
  )
)

exports. default = _react.memo.call(void 0, ListSearchField)
